import { Typography } from '@mui/material'
import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import { ISchoolBlog } from './useBlogs'
import Link from 'next/link'
import { generateArticleUrl } from '../../services/utils'
import { ArrowRight } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'

const GoToBlogPostDetailsButton = (props: {
  school: ISchool
  post: ISchoolBlog
  buttonLabel?: string
}) => {
  const theme = useTheme()

  const postUrl = generateArticleUrl(props.post)
  return (
    <>
      <Link href={postUrl}>
        <Typography
          color={'primary'}
          style={{
            color: theme.palette.primary.light,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          }}
          component={'a'}
          href={postUrl}
        >
          {props.buttonLabel || 'continue reading'} <ArrowRight />
        </Typography>
      </Link>
    </>
  )
}

export default GoToBlogPostDetailsButton
